import { render, staticRenderFns } from "./constructionEnterpriseDiagnosisResult.vue?vue&type=template&id=1bfb84b4&scoped=true"
import script from "./constructionEnterpriseDiagnosisResult.vue?vue&type=script&lang=js"
export * from "./constructionEnterpriseDiagnosisResult.vue?vue&type=script&lang=js"
import style0 from "./constructionEnterpriseDiagnosisResult.vue?vue&type=style&index=0&id=1bfb84b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfb84b4",
  null
  
)

export default component.exports